/* Native scrolling, progressive enhancement and a single frame scheduler. */
(() => {
  const motion = {get matches(){return document.body.dataset.heerMotion === 'off'},addEventListener(type,callback){document.addEventListener('heer:motion-change',callback)}};
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const scenes = new Set();
  let pending = false;
  const clamp = n => Math.min(1, Math.max(0, n));
  const update = () => {
    pending = false;
    for (const scene of scenes) {
      if (!scene.isConnected) { scenes.delete(scene); continue; }
      if (motion.matches) continue;
      const box = scene.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) continue;
      const isMaterial = scene.matches('heer-material');
      const progress = isMaterial ? clamp((innerHeight * .65 - box.top) / (innerHeight * .95)) : clamp(-box.top / Math.max(1, box.height - innerHeight));
      scene.style.setProperty('--hr-progress', progress.toFixed(4));
      if (isMaterial) scene.style.setProperty('--hr-curtain', (1-progress).toFixed(4));
    }
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  const reveal = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      if (!motion.matches) entry.target.classList.add('hr-inview');
      reveal.unobserve(entry.target);
    }
  }, { threshold: .08 }) : null;
  const mount = root => {
    root.querySelectorAll('heer-cinematic.hr-motion, heer-material.hr-motion').forEach(scene => {
      if (!motion.matches && !window.Shopify?.designMode) scene.classList.add('hr-motion-ready');
      scenes.add(scene);
    });
    root.querySelectorAll('[data-hr-reveal]').forEach(el => reveal?.observe(el));
    schedule();
  };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  motion.addEventListener('change', () => {
    for (const scene of scenes) scene.classList.toggle('hr-motion-ready', !motion.matches && !window.Shopify?.designMode);
    schedule();
  });
  let pointerFrame = 0;
  document.addEventListener('pointermove', event => {
    if (!fine.matches || motion.matches || pointerFrame) return;
    const target = event.target.closest('[data-hr-hover]');
    if (!target) return;
    pointerFrame = requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect();
      target.style.setProperty('--hr-x', `${event.clientX-rect.left}px`);
      target.style.setProperty('--hr-y', `${event.clientY-rect.top}px`);
      pointerFrame = 0;
    });
  }, { passive: true });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('heer-cinematic, heer-material').forEach(el => scenes.delete(el));
    event.target.querySelectorAll('[data-hr-reveal]').forEach(el => reveal?.unobserve(el));
  });
  mount(document);
})();
